import { getJSON } from '@store/ultile';
import globalConfig from '@utiles/globalConfig';
const MAIN_HOST = globalConfig.getMainHost();
const gameId = globalConfig.getHrefParam('gameId') || globalConfig.getHrefParam('gameID') || globalConfig.getHrefParam('game_id') || ''
export default {
  data() {
    return {
      isJpLimitPopup: false,
      jpLimitPopupTitle: '日本の決済チャネル調整に関する重要なお知らせ',
    };
  },
  created() {
    if ([191, 175, 263, 285, 331].includes(+gameId)) {
      this.checkJpLimitPopup();
    }
  },
  computed: {
    jpLimitPopupContent() {
      if (+gameId === 191) {
        return 'プレイヤーの皆様:\n\n日頃のご愛顧誠にありがとうございます。より安全な決済環境を提供するため、\n【2025年12月16日 17:00(UTC+9)】に以下の決済システム調整を実施いたします：\n公式サイトのチャージプラットフォーム【および / PCでの決済機能 / ブラウザゲームの決済機能】のサービスを終了\n\n変更内容\n第三者決済チャネルとの契約が満了し、更新がないため、公式サイトのチャージプラットフォームは予定通り閉鎖されます。\n終了後は以下の公式チャネルでのみチャージが可能となります：\niOSユーザー：App Store（アプリ内課金）\nAndroidユーザー：Google Playストア（アプリ内課金）\n\n注意事項\n1. 【PC / ブラウザ】ユーザーは引き続き通常通りログインしてプレイできます。キャラクターデータはモバイル端末とリアルタイムで同期されますが、決済機能のみ終了いたします。\n2. 公式サイトのチャージクーポンの配布も同時に終了しますが、2025年12月16日 17:00(UTC+9)までに受け取ったクーポンは有効期限まで使用可能です。\n3. 公式サイトのチャージプラットフォームで既にチャージしたゲーム内通貨やアイテムは引き続き通常通り使用できます。\n4. 一部の決済方法（コンビニ払い/クレジットカードなど）では入金に遅延が生じる場合があります。2025年12月16日 17:00(UTC+9)までにチャージが反映されない場合（弊社で入金が確認できない場合）、そのチャージは自動的に無効となりますので、チャージのタイミングにご注意ください。\n\n今回の変更はお客様のゲームデータやアカウントの安全性に影響を与えることはございません。ご不明な点がございましたら、公式カスタマーサポートまでお問い合わせください。\n\nご理解とご支援に重ねて感謝申し上げます。'
      }
      return 'プレイヤーの皆様:\n\n日頃のご愛顧誠にありがとうございます。より安全な決済環境を提供するため、\n【2025年12月1日 17:00(UTC+9)】に以下の決済システム調整を実施いたします：\n公式サイトのチャージプラットフォーム【および / PCでの決済機能 / ブラウザゲームの決済機能】のサービスを終了\n\n変更内容\n第三者決済チャネルとの契約が満了し、更新がないため、公式サイトのチャージプラットフォームは予定通り閉鎖されます。\n終了後は以下の公式チャネルでのみチャージが可能となります：\niOSユーザー：App Store（アプリ内課金）\nAndroidユーザー：Google Playストア（アプリ内課金）\n\n注意事項\n1. 【PC / ブラウザ】ユーザーは引き続き通常通りログインしてプレイできます。キャラクターデータはモバイル端末とリアルタイムで同期されますが、決済機能のみ終了いたします。\n2. 公式サイトのチャージクーポンの配布も同時に終了しますが、2025年12月1日 17:00(UTC+9)までに受け取ったクーポンは有効期限まで使用可能です。\n3. 公式サイトのチャージプラットフォームで既にチャージしたゲーム内通貨やアイテムは引き続き通常通り使用できます。\n4. 一部の決済方法（コンビニ払い/クレジットカードなど）では入金に遅延が生じる場合があります。2025年12月1日 17:00(UTC+9)までにチャージが反映されない場合（弊社で入金が確認できない場合）、そのチャージは自動的に無効となりますので、チャージのタイミングにご注意ください。\n\n今回の変更はお客様のゲームデータやアカウントの安全性に影響を与えることはございません。ご不明な点がございましたら、公式カスタマーサポートまでお問い合わせください。\n\nご理解とご支援に重ねて感謝申し上げます。'
    }
  },
  methods: {
    showJpLimitPopup() {
      this.isJpLimitPopup = true;
    },
    hideJpLimitPopup() {
      this.isJpLimitPopup = false;
    },
    checkJpLimitPopup() {
      getJSON(`https://gstore.${MAIN_HOST}/client_info`, {}).then(({ errmsg, data }) => {
        if (errmsg === '') {
          if (data?.location === 'JP') {
            this.showJpLimitPopup();
          } else {
            this.hideJpLimitPopup();
          }
        } else {
          this.hideJpLimitPopup();
        }
      }).catch(() => {
        this.hideJpLimitPopup();
      });
    }
  },
};
